import { ApiSmpStream, IApiSmpStreamDestinationReq } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

import { useContextApp } from "@/screens/app/context/app";

const KEY = "smp.stream.destination";

export const useSmpStreamDestinationList = (options?: {
  req?: IApiSmpStreamDestinationReq;
  useQueryOptions?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiSmpStream.Destination.list>>>,
    "queryKey" | "queryFn"
  >;
}) => {
  const {
    state: { organizationId },
  } = useContextApp();

  const {
    data: streamDestinationList,
    isLoading: isStreamDestinationListLoading,
    error: streamDestinationListError,
  } = useQuery(
    [KEY, { req: options?.req, organizationId }],
    () => ApiSmpStream.Destination.list(options?.req),
    options?.useQueryOptions,
  );

  return {
    isStreamDestinationListLoading,
    streamDestinationList,
    streamDestinationListError,
  };
};

useSmpStreamDestinationList.KEY = KEY;
